<div class="modal-header" id="individualization-material-serial-modal-title">
    <h3 class="modal-title" id="modal-title">{{ model.header }}</h3>
    <span class="close" (click)="onCancel()">&times;</span>
</div>

<div class="modal-body">
    <form [formGroup]="modalForm">
        <div class="row mb-3">
            <label class="col-12 text-start col-form-label" for="material-number">{{ model.title1 }}</label>
            <div class="col-12">
                <input
                    type="text"
                    class="form-control individualization-dropdown"
                    formControlName="materialNumber"
                    (focus)="onMaterialNumberInput()"
                    (input)="onMaterialNumberInput()"
                    id="material-number"
                />
                <ng-container *ngrxLet="chosenMaterialDescription$ as chosenMaterialDescription">
                    <span *ngIf="chosenMaterialDescription.length > 0 && !showMaterialDropdown" class="ms-auto">
                        {{ chosenMaterialDescription }}
                    </span>
                </ng-container>
                <ng-container *ngrxLet="filteredMaterialDescription$ as materialNumberDescription">
                    <div class="dropdown" *ngIf="showMaterialDropdown && materialNumberDescription?.length">
                        <div
                            class="dropdown-item"
                            *ngFor="let material of materialNumberDescription"
                            (click)="selectMaterialNumber(material)"
                        >
                            {{ material.materialDescription }}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-12 text-start col-form-label" for="serial-number">{{ model.title2 }}</label>
            <div class="col-12">
                <input
                    type="text"
                    class="form-control individualization-dropdown"
                    formControlName="serialNumber"
                    (focus)="onSerialNumberInputFocus()"
                    id="serial-number"
                />
                <ng-container *ngrxLet="filteredSerialNumber$ as filteredSerialNumber">
                    <div class="dropdown" *ngIf="showSerialDropdown && filteredSerialNumber.length">
                        <div
                            class="dropdown-item"
                            *ngFor="let serialNumber of filteredSerialNumber"
                            (click)="selectSerialNumber(serialNumber.sernr)"
                        >
                            {{ serialNumber.sernr }}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-12 text-start col-form-label" for="material-description">{{ model.description }}</label>
            <div>
                <input
                    type="text"
                    class="col-12 form-control"
                    formControlName="description"
                    id="material-description"
                />
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">{{ model.cancel }}</button>
    <button type="button" class="btn btn-primary" [disabled]="modalForm.invalid" (click)="onSubmit()">
        {{ model.save }}
    </button>
</div>
